/**
 * Header — centralized copy strings (AOF 25, i18n posture).
 */

export const headerCopy = {
  brand: "animachord",
  rehearsalBadge: "Rehearsal",
  homeLabel: "animachord home",
} as const;
